import { render, staticRenderFns } from "./school-view-page.vue?vue&type=template&id=60a52638&scoped=true&"
import script from "./school-view-page.vue?vue&type=script&lang=js&"
export * from "./school-view-page.vue?vue&type=script&lang=js&"
import style0 from "./school-view-page.vue?vue&type=style&index=0&id=60a52638&lang=scss&scoped=true&"
import style1 from "./school-view-page.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a52638",
  null
  
)

export default component.exports